const Foundation = require("foundation-sites");
const dateFormatPattern = /^\d{2}\/\d{2}\/\d{4}$/;
export function dateValidator($el) {
  if (!$el.val()) {
    return true;
  }
  if (!dateFormatPattern.test($el.val())) {
    return false;
  }
  const date = $el.val().split("/").reverse().join("-");
  const parsedDate = new Date(date);
  if (isNaN(parsedDate.getTime())) {
    return false;
  }
  return parsedDate.toISOString().split("T")[0] === date;
}
Foundation.Abide.defaults.validators["date"] = dateValidator;
